import React, {useState} from 'react';
import css from './SearchSelect.module.scss';
import Select, {components} from "react-select";
import {Field} from "formik";
import {withTranslation} from "../../../i18n";

const namespacesRequired = ['common'];

const SearchSelect = (props) => {

  if (props.value == null || props.value == undefined) {
    props.onChange && props.onChange(props.defaultValue ? props.defaultValue.value ? props.defaultValue.value : props.defaultValue : props.options[0].value, props.inputName);
  }

  const findValue = (val) => {
    let res = props.options.find(opt => opt.value === val);
    if (!res) {
      res = props.options.find(opt => opt.label === String(val).toUpperCase());
      if (!res) {
        return null;
      }
    }
    return res;
  };
  const DropdownIndicator = (props) => {
    return (<components.DropdownIndicator {...props}>
        <span className="Dropdown-arrow  select__arrow___AAfCW undefined"/>
      </components.DropdownIndicator>
    );
  };
  const [oldValue, setOldValue] = useState(findValue(props.value || props.defaultValue));

  const formatOptionLabel = ({label, value}) => (
    <div className={props.value === value ? "selected_value" : null}>{label}</div>
  );

  return (<Field name={props.inputName}
                 id={props.inputId}
  >
    {({field: {value}, form: {setFieldValue, setFieldTouched, touched, submitCount}}) => (
      <div className={`${css.input__wrapper} ${props.customClass}`} ref={props.anchorRef}>
        <label className={css.label}>
          {props.label} {props.required && "*"}
        </label>
        <Select
          defaultValue={findValue(props.defaultValue)}
          formatOptionLabel={formatOptionLabel}
          options={props.options}
          className={`${css.search_select} ${props.fullWidth ? css.search_select__full_width : ''}`}
          isDisabled={props.disabled}
          isSearchable={true}
          components={{DropdownIndicator, IndicatorSeparator: () => null}}
          onChange={(newValue) => {
            if (!props.onChange || props.onChange(newValue, oldValue)) {
              setFieldTouched(props.inputName, true, false);
              setFieldValue(props.inputName, newValue.value, true);
              setOldValue(newValue);
            }
          }}
          onBlur={(event) => {
            setFieldTouched(props.inputName, true);
            props.makeErrorsVisible && props.makeErrorsVisible();
            props.onBlur && props.onBlur(event);
          }}
          value={findValue(props.value || props.defaultValue)}
          maxMenuHeight={200}
          placeholder={props.inputPlaceholder}
        />

        {!props.hideErrors && (touched[props.inputName] || submitCount > 0) && (props.errors && props.errors[props.inputName]) && <div
          className={css.input__errors}
        >
          <p>{props.t('common:errors.' + props.errors[props.inputName])}</p>
        </div>}
      </div>)}
  </Field>);

};

export default withTranslation(namespacesRequired)(SearchSelect);
